export const ECRAN_DEMARRAGE_PROJET_DEFAUTS = {
  file_id : null,
  media_type : "image",
  media_url : null,
  image_url : null,
  video_url : null,
  loop : true,
  loop_start_s : 0,
  loop_end_s : null,
  fadeout_ms : 1200,
  afficher_desktop : true,
  afficher_mobile : true,
};

export const ECRAN_DEMARRAGE_PROJET_BORNES = {
  fadeout_ms : {min : 0, max : 10000, step : 50},
  loop_time_s : {min : 0, max : 86400, step : 0.1},
};

export const ECRAN_DEMARRAGE_MEDIA_TYPES = Object.freeze (["image", "video"]);

function objet_simple (pValeur)
  {
    return pValeur && typeof pValeur === "object" && !Array.isArray (pValeur)
      ? pValeur
      : {};
  }

function texte_id (pValeur)
  {
    const tTexte = typeof pValeur === "string" ? pValeur.trim () : "";
    return tTexte || null;
  }

export function normalise_type_media_ecran_demarrage_projet (pValeur)
  {
    const tType = typeof pValeur === "string" ? pValeur.trim ().toLowerCase () : "";
    return ECRAN_DEMARRAGE_MEDIA_TYPES.includes (tType)
      ? tType
      : ECRAN_DEMARRAGE_PROJET_DEFAUTS.media_type;
  }

export function type_media_ecran_demarrage_depuis_fichier (pFichier)
  {
    if (!pFichier) return null;
    const tType = typeof pFichier.type === "string" ? pFichier.type.toLowerCase () : "";
    const tNom = typeof pFichier.name === "string"
      ? pFichier.name.toLowerCase ()
      : (typeof pFichier.fileName === "string" ? pFichier.fileName.toLowerCase () : "");
    if (tType.startsWith ("video/") || /\.(mp4|m4v|mov|webm|ogv)$/i.test (tNom))
      return "video";
    if (tType.startsWith ("image/") || /\.(svg|png|jpe?g|webp|gif)$/i.test (tNom))
      return "image";
    return null;
  }

function borne_nombre (pValeur, pMin, pMax, pDefaut)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pDefaut;
    return Math.max (pMin, Math.min (pMax, tNombre));
  }

function nombre_optionnel_borne (pValeur, pMin, pMax)
  {
    if (pValeur === null || pValeur === undefined || pValeur === "") return null;
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return null;
    return Math.max (pMin, Math.min (pMax, tNombre));
  }

function booleen (pValeur, pDefaut)
  {
    if (typeof pValeur === "boolean") return pValeur;
    if (typeof pValeur === "number") return pValeur !== 0;
    if (typeof pValeur === "string")
      {
        const tTexte = pValeur.trim ().toLowerCase ();
        if (["true", "1", "oui", "yes", "on"].includes (tTexte)) return true;
        if (["false", "0", "non", "no", "off"].includes (tTexte)) return false;
      }
    return pDefaut;
  }

export function normalise_ecran_demarrage_projet (pValeur)
  {
    const tSource = objet_simple (pValeur);
    const tBornesFadeout = ECRAN_DEMARRAGE_PROJET_BORNES.fadeout_ms;
    const tBornesBoucle = ECRAN_DEMARRAGE_PROJET_BORNES.loop_time_s;
    const tFileId = texte_id (tSource.file_id);
    const tMediaType = tFileId
      ? normalise_type_media_ecran_demarrage_projet (tSource.media_type)
      : ECRAN_DEMARRAGE_PROJET_DEFAUTS.media_type;
    const tLoopStart = borne_nombre (
      tSource.loop_start_s,
      tBornesBoucle.min,
      tBornesBoucle.max,
      ECRAN_DEMARRAGE_PROJET_DEFAUTS.loop_start_s
    );
    const tLoopEndBrut = nombre_optionnel_borne (
      tSource.loop_end_s,
      tBornesBoucle.min,
      tBornesBoucle.max
    );
    const tLoopStartArrondi = Math.round (tLoopStart * 10) / 10;
    const tLoopEndArrondi = tLoopEndBrut === null
      ? null
      : Math.round (tLoopEndBrut * 10) / 10;
    return {
      file_id : tFileId,
      media_type : tMediaType,
      media_url : texte_id (
        tSource.media_url
        || (tMediaType === "video" ? tSource.video_url : tSource.image_url)
        || tSource.image_url
      ),
      image_url : texte_id (tSource.image_url),
      video_url : texte_id (tSource.video_url),
      loop : booleen (tSource.loop, ECRAN_DEMARRAGE_PROJET_DEFAUTS.loop),
      loop_start_s : tLoopStartArrondi,
      loop_end_s : tLoopEndArrondi !== null && tLoopEndArrondi > tLoopStartArrondi
        ? tLoopEndArrondi
        : null,
      fadeout_ms : Math.round (borne_nombre (
        tSource.fadeout_ms,
        tBornesFadeout.min,
        tBornesFadeout.max,
        ECRAN_DEMARRAGE_PROJET_DEFAUTS.fadeout_ms
      )),
      afficher_desktop : booleen (
        tSource.afficher_desktop,
        ECRAN_DEMARRAGE_PROJET_DEFAUTS.afficher_desktop
      ),
      afficher_mobile : booleen (
        tSource.afficher_mobile,
        ECRAN_DEMARRAGE_PROJET_DEFAUTS.afficher_mobile
      ),
    };
  }
